module.exports = __webpack_public_path__ + "static/img/privacy-10.c384952.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-10.png
// module id = H29W
// module chunks = 1